module.exports = __webpack_public_path__ + "static/media/v10.79210841.mp4";